<template>
  <Menu></Menu>
  <div id="box">
    <div v-if="loading" class="loadingSpinner"><span class="spinner-border"></span></div>
    <!-- =========================================================================================================== -->
    <div class="container mb-2 p-0">
      <div class="row p-0">
        <div class="col p-0 text-center">
          <h5 class="fw-bold d-inline-block bi-cash-coin">&nbsp; Cashier</h5>
          <hr>
        </div>
      </div>
      <!-- =========================================================================================================== -->
      <div class="row p-0 mb-2">
        <div class="col-3 p-0">
          <div class="input-group w-100">
            <span class="input-group-text w-25">Branch</span>
            <select class="form-select" v-model="currBranch" @change="branchChanged()">
              <option v-for="b in branches" :key="b._id" :value="b._id">{{ b.name }}</option>
            </select>
          </div>
        </div>
        
        <div class="col-4">
          <div class="input-group w-1002">
              <span class="input-group-text w-25">Tires</span>
              <Select2 id="tirePickup" :options="tires" :settings="tires_select2_settings" @select="tireSelected($event)"/>
            </div>
        </div>
        
        <div class="col p-0">
          <div class="input-group radius-zero w-100">
              <span class="input-group-text w-20">{{ translateType(currCustomer.type) }}</span>
              <Select2 id="customers" :clearable="true" :settings="customers_select2_settings" @select="customerSelected($event)"/>
              <a class="btn btn-warning bi-pencil-fill" @click="showEditCustomer()"></a>
              <a class="btn btn-success bi-plus-circle" @click="showAddCustomer()"></a>
              <a class="btn btn-danger bi-x" @click="discardCustomer()"></a>
            </div>
        </div>

      </div>
      <!-- =========================================================================================================== -->
      <div class="row p-0">
        <div class="col p-0">
          <table class="table table-sm table-bordered table-striped table-hover table-fixed">
            <!-- ----------------------------------------------- -->
            <thead>
              <tr class="table-dark">
                <th class="">Product</th>
                <th class="text-center w-10">Price</th>
                <th class="text-center w-10">Quantity</th>
                <th class="text-center w-10">Value</th>
                <th class="text-center w-30"><span class="bi-gear"></span></th>
              </tr>
            </thead>
            <!-- ----------------------------------------------- -->
            <tbody style="height: calc(100vh - 360px)">        
              <tr v-for="item, index in items" :key="item._id">
                <td class="position-relative">
                  {{ item.name }}
                  <span v-if="item.prod_date" class='subtitle'>Production Date: {{ item.prod_date }}</span>
                  <span v-if="item.discount" class="badge text-bg-success disc-badge">{{ (item.discount).toFixed(2) }}%</span>
                </td>
                <td class="text-center w-10">{{ item.price }}</td>
                <td class="text-center w-10">{{ item.quantity }}</td>
                <td class="text-center w-10 fw-bold">
                  <span v-bind:class="item.discount ? 'text-decoration-line-through' : ''">
                    {{ ((item.price * item.quantity) || 0).toFixed(2) }}
                  </span>
                  <span v-if="item.discount" class="d-block">
                    {{ ((item.price * item.quantity) * (1 - item.discount / 100)).toFixed(2) }}
                  </span>
                </td>
                <td class="w-30 text-center unselect">
                  <a class='btn btn-success bi-plus-lg px-2 mx-1' @click="incQuantity(index)"></a>
                  <a class='btn btn-warning bi-dash-lg px-2 mx-1' @click="decQuantity(index)"></a>
                  <a class='btn btn-danger bi-trash px-2 mx-1' @click="delItem(index)"></a>
                  <a v-if="maxDiscount > 0" class='btn btn-primary bi-percent mx-3 px-2' @click="showDiscount(index)">Discount</a>
                </td>
              </tr>
            </tbody>
            <!-- ----------------------------------------------- -->
          </table>
        </div>
      </div>
      <!-- =========================================================================================================== -->
      <div class="row p-0">
        <div class="col p-0">
          <table class="table table-sm table-bordered fw-bold">
            <tbody>
              <tr>
                <td>Subtotal</td>
                <td class="w-55 text-center">{{ formatMoney(subtotal) }} EGP</td>
              </tr>
              <!-- --------------------- -->
              <!-- <tr v-if="discount > 0">
                <td>Discount {{ discount }} %</td>
                <td class="w-55 text-center">{{ subtotal_discount.toFixed(2) }}</td>
              </tr> -->
              <!-- --------------------- -->
              <tr v-if="tax > 0">
                <td>VAT {{ tax }} %</td>
                <td class="w-55 text-center">{{ formatMoney(subtotal * tax / 100) }} EGP</td>
              </tr>
              <!-- --------------------- -->
              <tr class="table-secondary">
                <td>Total</td>
                <td class="w-55 text-center">{{ formatMoney(total) }} EGP</td>
              </tr>
            </tbody>
            </table>
        </div>
      </div>
      <!-- =========================================================================================================== -->
      <div class="row p-0">
        <div class="col p-0">
          <button class="btn btn-danger w-100" @click="clearCart()">
            <span class="bi-x-square-fill">&nbsp; Clear </span>
          </button>
        </div>
        <div class="col">
          <button class="btn btn-warning w-100" @click="showAddOther()">
            <span class="bi-alt">&nbsp; Add Other </span>
          </button>
        </div>
        <div class="col p-0">
          <button class="btn btn-success w-100 fw-bold" @click="showCheckout()">
            <span class="bi-check-square-fill">&nbsp; Checkout </span>
          </button>
        </div>
      </div>
      <!-- =========================================================================================================== -->
    </div>
    <!-- =========================================================================================================== -->
    <!-- =========================================================================================================== -->
    <div id="discountModal" ref="discountModal" class="modal fade">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Apply Discount</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body text-center">
            <table class="table table-sm table-bordered unselect fw-bold">
              <tbody>
                <tr>
                  <td class="w-50">Price</td>
                  <td colspan="2" class="w-50">{{ currDiscount.price }}</td>
                </tr>
                <tr>
                  <td class="w-50">Quantiy</td>
                  <td colspan="2" class="w-50">{{ currDiscount.quantity }}</td>
                </tr>
                <tr class="table-secondary">
                  <td class="w-50">Value Before</td>
                  <td colspan="2" class="w-50">{{ currDiscount.price * currDiscount.quantity }}</td>
                </tr>
                <tr>
                  <td colspan="3"></td>
                </tr>
                <tr class="">
                  <td class="w-50 text-danger">Percent 0% - {{ maxDiscount }}%</td>
                  <td class="w-40 p-0">
                    <input v-model.number="currDiscount.discount" class="inside w-100 text-center fw-bold text-danger" @input="discountChanged($event)">
                  </td>
                  <td class="w-10 text-danger">%</td>
                </tr>
                <tr class="">
                  <td class="w-50 text-danger">Value 0 - {{ (currDiscount.price * currDiscount.quantity) * maxDiscount/100 }}</td>
                  <td class="w-50 p-0" colspan="2" >
                    <input v-model.number="currDiscount.value" class="inside w-100 text-center fw-bold text-danger" @input="discountValueChanged($event)">
                  </td>
                </tr>
                <tr>
                  <td colspan="3"></td>
                </tr>
                <tr class="table-secondary">
                  <td class="w-50">Value After</td>
                  <td colspan="2" class="w-50">{{ ((currDiscount.price * currDiscount.quantity) * (1 - (currDiscount.discount || 0) / 100)).toFixed(2) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col text-center">
                  <a class="btn btn-success w-50" @click="applyDiscount()">Apply</a>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
    <!-- =========================================================================================================== -->
    <div id="addModal" ref="addModal" class="modal fade">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">{{ currProduct.name }}</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body text-center">
            <p class="text-start fw-bold">Price: {{ currProduct.price }}</p>
            <table class="table table-sm table-striped table-hover table-bordered unselect">
              <thead>
                <tr>
                  <th class="text-center">Prod Date</th>
                  <th class="text-center">Available</th>
                  <th class="text-center w-25 bi-gear"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="x, index in currProduct.quantities" :key="x._id">
                  <td>{{ x.prod_date }}</td>
                  <td>{{ x.avail }}</td>
                  <td>
                    <a class='btn btn-success bi-plus-lg w-30' @click="addItem(index)"></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
    <!-- =========================================================================================================== -->
    <div id="addOtherProduct" ref="addOtherProduct" class="modal fade">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Other Products</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body">
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Search</span>
              <Select2 id="otherPickup" v-model="currOther.id" :options="others" :settings="others_select2_settings" @select="otherSelected($event)"/>
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Name</span>
              <input class="form-control" type="text" disabled="true" v-model.trim="currOther.name">
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Price</span>
              <input class="form-control" type="text" disabled="true" v-model="currOther.price">
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Amount</span>
              <input class="form-control" type="number" v-model.trim="currOther.amount">
            </div>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col">
                  <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
                </div>
                <div class="col">
                  <a class="btn btn-success w-100" @click="addOtherItem()">Add</a>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
    <!-- =========================================================================================================== -->
    <div id="checkoutModal" ref="checkoutModal" class="modal fade">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Checkout</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body text-center">
          <!-- ============================================================= customer & invoice type -->
            <template v-if="currCustomer._id" >
              <div class="input-group w-100 mb-2">
                <span class="input-group-text w-20">Customer</span>
                <span class="input-group-text w-80">{{ currCustomer.name }} {{ currCustomer.phone }}</span>
              </div>

              <div v-if="currCustomer.cars.length">
                <div class="input-group w-100 mb-2">
                  <span class="input-group-text w-20">Car</span>
                  <select ref="car" class="form-select" @change="carChanged()">
                    <option v-for="c, i in currCustomer.cars" :key=i :value=i>{{ c.plate.join(' ') }} {{ c.brand }}</option>
                  </select>
                </div>
    
                <div class="input-group w-100 mb-2">
                  <span class="input-group-text w-20">Milage</span>
                  <input type="number" class="form-control w-70" v-model.number="invoice.car.miles">
                  <span class="input-group-text w-10">Km</span>
                </div>
              </div>
              

              <div class="input-group w-100 mb-2">
              <span class="input-group-text w-40">Invoice Type</span>
              <select class="form-select" v-model="invoice.type">
                <option value='full'>Full Amount</option>
                <option value='postpaid'>Postpaid</option>
              </select>
            </div>

            <hr>

          </template>
          <!-- ============================================================= delivery -->
          <template>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-40">Delivery Address</span>
              <input type="text" class="form-control" v-model.trim="invoice.delivery_address">
            </div>

            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-40">Delivery Fees</span>
              <input type="number" class="form-control text-center" v-model.number="invoice.delivery_fees">
            </div>

            <hr>
          </template>
          <!-- ============================================================= details -->
            <div class="input-group w-100 mb-2 fw-bold">
              <span class="input-group-text w-20 text-danger">Total</span>
              <span class="input-group-text w-80 text-danger text-center d-block select">{{ formatMoney(total + invoice.delivery_fees) }}</span>
            </div>

            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-40">Payment Type</span>
              <select class="form-select" v-model="invoice.method" @change="methodChanged()">
                <option value='cash'>Cash</option>
                <option value='visa'>Visa</option>
              </select>
            </div>

            <div class="input-group w-100 mb-2 fw-bold">
              <span class="input-group-text w-20 text-success">Paid</span>
              <input type="number" class="form-control text-success text-center" v-model.number="invoice.paid">
            </div>
            
            <div v-if="invoice.method == 'cash'">
              <div class="input-group w-100 mb-2">
                <span class="input-group-text w-20">Change</span>
                <input type="number" class="form-control text-center" disabled="true" :value="(invoice.paid  - invoice.delivery_fees - total).toFixed(2)">
              </div>
              
            </div>
            <div v-else>
              <div class="input-group w-100 mb-2">
                <span class="input-group-text w-50">Transaction ID</span>
                <input type="text" class="form-control" v-model="invoice.ref_num">
              </div>
            </div>
          <!-- ============================================================= alerts -->
            <template v-if="invoice.type =='full'">
              <div v-if="invoice.paid < overall" class="form-text bg-danger-subtle w-100 mb-2 p-2">
                <span class="bi-exclamation-triangle-fill">&nbsp; Paid amount is insufficient</span>
              </div>
            </template>
            <template v-else>
              <div v-if="invoice.paid < overall" class="form-text bg-warning-subtle w-100 mb-2 p-2">
                <span class="bi-exclamation-triangle-fill">&nbsp; {{ formatMoney(overall - invoice.paid) }} Will be withdrawl from customer balance</span>
              </div>
            </template>


          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col">
                  <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
                </div>
                <div class="col">
                  <button class="btn btn-success w-100" @click="checkout()">Checkout</button>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
    <Invoice ref="invoice"></Invoice>
    <AddCustomer ref="addCustomer" v-model:loading="loading"></AddCustomer>
    <EditCustomer ref="editCustomer" v-model:loading="loading"></EditCustomer>
    <!-- =========================================================================================================== -->
  </div>

</template>
<!-- ******************************************************** -->
<script>
  import AddCustomer from '@/components/AddCustomer.vue';
import EditCustomer from '@/components/EditCustomer.vue';
import Invoice from '@/components/Invoice.vue';
  const $ = require('jquery');
  export default {
    name: 'CashierPage',
    components:{
      AddCustomer,
      EditCustomer,
      Invoice,
    },
    data(){
      return {
        loading: false,
        //--------------------------
        branches: [],
        currBranch: null,
        //--------------------------
        tires: [],
        //--------------------------  others
        others: [],
        currOther:{
          id: '',
          name: '',
          price: '',
          amount: 0,
        },
        //--------------------------
        currCustomer: {
          _id: null,
          name: '',
          nameOriginal: '',
          phone: '',
          type: '',
          cars: [],
        },
        //--------------------------
        currDiscount:{
          price: 0,
          quantity: 0,
          discount: 0,
          value: 0,
        },
        //--------------------------
        invoice:{
          method: 'cash',
          type: 'full',
          ref_num: '',
          delivery_address: '',
          delivery_fees: '',
          paid: 0,
          car:{
            _id: '',
            plate: '',
            brand: '',
            miles: 0,
          },
        },
        items: [],
        currProduct: {
          index: '',
          id: '',
          name: '',
          price: 0,
          quantities: [],
        },
        //--------------------------
        discount: 0,
        maxDiscount: 0,
        tax: 0,
        ws_rate: 0,
        //--------------------------
        tires_select2_settings:{
          theme: "bootstrap-5",
          placeholder: 'Search for Products',
          width: '280px',
        },
        //--------------------------
        customers_select2_settings:{
          theme: "bootstrap-5",
          placeholder: 'Search for Customers',
          minimumInputLength: 3,
          maximumInputLength: 30,
          width: '300px',
          ajax: {
            url: `${this.$service.baseUrl}/customer/searchCustomers`,
            headers: { "Authorization" : this.$store.state.token },
            delay: 500, cache: false,
          },
        },
        //--------------------------
        others_select2_settings:{
          theme: "bootstrap-5",
          placeholder: 'Search for Other Product',
          width: '350px',
        },
        //--------------------------
      }
    },
    async created() {
      await this.loadBranches();
      this.currBranch = this.branches.length ? this.branches[0]._id : ''; 
      await this.loadTires();
      await this.loadOthers();
      await this.loadCart();

      var code = "", reading = false;
      document.addEventListener('keypress', (e) => {
        if (e.keyCode === 13) {
            if(code.length >= 8) {
              this.onBarcodeScan(code);
              code = "";
            }
        }
        else { code += e.key; }
        if(!reading) {
            reading = true;
            setTimeout(() => { code = ""; reading = false;}, 200);
        }
      });

    },
    ////////////////////////////////////////////////////////////////
    computed:{
      subtotal(){
        if(!this.items) return "0.00";
        var x = this.items.reduce((acc, x)=> acc + (x.price * x.quantity) * (1 - (x.discount || 0) / 100), 0);
        return parseFloat(x.toFixed(2))
      },
      total(){
        if(!this.items) return "0.00";
        var x = this.subtotal * (this.tax/100 + 1);
        return parseFloat(x.toFixed(2))
      },
      overall(){
        return this.total + this.invoice.delivery_fees || 0;
      }
    },
    ////////////////////////////////////////////////////////////////
    methods:{
      //**********************************************************
      async loadBranches(){
        this.loading = true;

        this.branches = [];
        var ack = await this.$service.getBranchesAbstract();
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.branches = ack.data;
        }
        this.loading = false;
      },
      //**********************************************************
      async loadTires(){
        this.loading = true;

        this.tires = [];
        var ack = await this.$service.getTiresAbstract();
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.tires = ack.data;
        }
        this.loading = false;
      },
      //**********************************************************
      async loadOthers(){
        this.loading = true;

        this.others = [];
        var ack = await this.$service.getOthersAbstract();
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.others = ack.data;
        }
        this.loading = false;
      },
      //**********************************************************
      async loadCart(){
        this.loading = true;

        this.items = [];
        this.maxDiscount = this.discount = this.tax = 0;
        var ack = await this.$service.getCart({ branch: this.currBranch });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.items = ack.data.items;
          this.discount = ack.data.discount;
          this.maxDiscount = ack.data.maxDiscount;
          this.tax = ack.data.tax;
          this.ws_rate = ack.data.ws_rate;
          if(ack.data.customer){
            this.currCustomer = ack.data.customer;
            $("#customers").append(new Option(`${this.currCustomer.name} ${this.currCustomer.phone}`, this.currCustomer._id, true, true)).trigger('change');
          }
          else{
            $("#customers").val(null).trigger('change');

          }
        }
        this.loading = false;
      },
      //**********************************************************
      async saveItems(){
        this.loading = true;

        var ack = await this.$service.saveCartItems({ 
          branch: this.currBranch, 
          items: this.items
        });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        
        this.loading = false;
      },
      //**********************************************************
      async saveCartCustomer(){
        this.loading = true;

        var ack = await this.$service.saveCartCustomer({ 
          branch: this.currBranch, 
          customer: this.currCustomer._id,
        });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        
        this.loading = false;
      },
      //**********************************************************
      async addItem(index){
        let curr = this.currProduct.quantities[index];
        var index2 = this.items.findIndex((x)=>x._id == this.currProduct.id && x.prod_date == curr.prod_date );
        
        this.loading = true;
        var needed = (index2 < 0) ? 1 : this.items[index2].quantity + 1;
        var ack = await this.$service.checkStock({ 
          branch: this.currBranch,
          product: this.currProduct.id,
          prod_date: curr.prod_date,
          amount: needed,
        });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else if(!ack.data){
          this.$toast('No Enough Stock');
        }
        else{
          if(index2 < 0){
            // this.$toast(this.currProduct.ws_price);
            let price = this.currProduct.price;
            if(this.currCustomer.type == 'premium_ws') price = this.currProduct.ws_price;
            else if(this.currCustomer.type == 'wholsaler') price = (this.currProduct.ws_price || 0) * (100 + this.ws_rate) / 100;
            this.items.push({
              _id: this.currProduct.id,
              name: this.currProduct.name,
              prod_date: curr.prod_date,
              price: price,
              quantity: 1,
            });
          }
          else{
            this.items[index2].quantity += 1;
          }
          await this.saveItems();
        }

        this.loading = false;
      },
      //**********************************************************
      async incQuantity(index){
        if(!this.items[index].prod_date){
          this.items[index].quantity += 1;
          await this.saveItems();
          return;
        }
        //-----------------------------------------
        this.loading = true;
        var ack = await this.$service.checkStock({ 
          branch: this.currBranch,
          product: this.items[index]._id,
          prod_date: this.items[index].prod_date,
          amount: this.items[index].quantity + 1,
        });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else if(ack.data){
          this.items[index].quantity += 1;
          await this.saveItems();
        }
        else{
          this.$toast('No Enough Stock');
        }
        this.loading = false;
      },
      //**********************************************************
      async decQuantity(index){
        if(this.items[index].quantity > 0){
          this.items[index].quantity -= 1;
        }
        if(this.items[index].quantity <= 0){
          this.items.splice(index, 1);
        }
        await this.saveItems();
      },
      //**********************************************************
      async delItem(index){
        this.items.splice(index, 1);
        await this.saveItems();
      },
      //**********************************************************
      async discountChanged(){
        if(isNaN(this.currDiscount.discount) || this.currDiscount.discount < 0){
          this.currDiscount.discount = 0;
        }
        if(this.currDiscount.discount > this.maxDiscount){
          this.currDiscount.discount = this.maxDiscount;
        }
        this.currDiscount.value = (this.currDiscount.price * this.currDiscount.quantity) * this.currDiscount.discount/100 ;
        // console.log("1111111");
      },
      //**********************************************************
      async discountValueChanged(){
        if(isNaN(this.currDiscount.value) || this.currDiscount.value < 0){
          this.currDiscount.value = 0;
          this.currDiscount.discount = 0;
          return;
        }
        var original = this.currDiscount.price * this.currDiscount.quantity;
        // var maxDiscountValue = original - (original * this.maxDiscount / 100);
        var maxDiscountValue = (this.currDiscount.price * this.currDiscount.quantity) * this.maxDiscount/100
        // console.log(maxDiscountValue);
        
        if(this.currDiscount.value > maxDiscountValue){
          this.currDiscount.value = maxDiscountValue;
        }
        this.currDiscount.discount = this.currDiscount.value / original * 100;
      },
      //**********************************************************
      async showDiscount(index){
        this.currDiscount.index = index;
        this.currDiscount.price = this.items[index].price
        this.currDiscount.quantity = this.items[index].quantity;
        this.currDiscount.discount = this.items[index].discount || 0
        this.currDiscount.value = (this.currDiscount.price * this.currDiscount.quantity) * this.currDiscount.discount/100 ;
        $('#discountModal').modal('show');
      },
      //**********************************************************
      async applyDiscount(){
        this.items[this.currDiscount.index].discount = parseFloat(this.currDiscount.discount);
        await this.saveItems();
        $('#discountModal').modal('hide');
      },
      //**********************************************************
      async clearCart(){
        this.items = [];
        this.currCustomer = {
          _id: null,
          name: '',
          nameOriginal: '',
          phone: '',
          cars: [],
        };
        this.loading = true;

        var ack = await this.$service.clearCart({ branch: this.currBranch });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        this.loading = false;
      },
      //**********************************************************
      async branchChanged(){
        this.loadCart();
      },
      //**********************************************************
      async tireSelected({id, text}){
        if(!this.currBranch) return this.$toast('Select a branch first');

        this.loading = true;
        $('#tirePickup').val(null).trigger('change');
        this.currProduct.id = id;
        this.currProduct.name = text;
        var ack = await this.$service.getStock({branch: this.currBranch, product: id});
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        if(!ack.data){
          this.$toast('Out of Stock');
        }
        else{
          this.currProduct.quantities = ack.data.quantities;
          this.currProduct.price = ack.data.price;
          this.currProduct.ws_price = ack.data.ws_price;
          $('#addModal').modal('show');
        }
        this.loading = false;
      },
      //**********************************************************
      async customerSelected({id}){
        this.loading = true;

        var ack = await this.$service.getCustomer({id: id});
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        if(!ack.data){
          this.$toast('Failed to fetch customer data');
        }
        this.currCustomer = ack.data;
        this.loading = false;

        await this.saveCartCustomer();
        await this.loadCart();
      },
      //**********************************************************
      async discardCustomer(){
        if(!this.currCustomer._id){
          return this.$toast("No customer selected");
        }
        this.currCustomer = {
          _id: null,
          name: '',
          nameOriginal: '',
          phone: '',
          cars: [],
        };
        $('#customers').val(null).trigger('change');
        await this.saveCartCustomer();
        await this.loadCart();
      },
      //**********************************************************
      async showEditCustomer(){
        if(!this.currCustomer._id){
          return this.$toast("Select a customer first");
        }
        await this.$refs.editCustomer.show(this.currCustomer._id, async(customer)=>{
          this.currCustomer = customer;
          $("#customers").append(new Option(`${this.currCustomer.name} ${this.currCustomer.phone}`, this.currCustomer._id, true, true)).trigger('change');
          await this.saveCartCustomer();
          await this.loadCart();
        });
      },
      //**********************************************************
      async showAddCustomer(){
        await this.$refs.addCustomer.show(async(customer)=>{
          this.currCustomer = customer;
          $("#customers").append(new Option(`${this.currCustomer.name} ${this.currCustomer.phone}`, this.currCustomer._id, true, true)).trigger('change');
          await this.saveCartCustomer();
          await this.loadCart();
        });
      },
      //**********************************************************
      async carChanged(){
        if(!this.$refs.car) return;
        var i = this.$refs.car.value;
        if(i >= 0){
          this.invoice.car._id = this.currCustomer.cars[i]._id;
          this.invoice.car.plate = this.currCustomer.cars[i].plate;
          this.invoice.car.brand = this.currCustomer.cars[i].brand;
          this.invoice.car.miles = this.currCustomer.cars[i].miles;
        }
      },
      //**********************************************************
      async methodChanged(){
        if(this.invoice.method == 'cash'){
          this.invoice.paid = 0;
        }
        else if(this.invoice.method == 'visa'){
          this.invoice.paid = this.total + this.invoice.delivery_fees;
        }
      },
      //**********************************************************
      async showCheckout(){
        if(!this.items.length){
          return this.$toast("Cart is empty");
        }
        this.carChanged();
        this.invoice.type = 'full';
        this.invoice.paid = 0;
        $('#checkoutModal').modal('show');
      },
      //**********************************************************
      async clearFiellds(){
        this.invoice.delivery_address = ''
        this.invoice.delivery_fees = ''
        this.invoice.paid = 0;
        this.invoice.ref_num = '';
      },
      //**********************************************************
      async checkout(){
        var insufficient = this.invoice.paid < this.overall;
        if(insufficient && (!this.currCustomer._id || this.invoice.type == 'full')){
          return this.$toast("Insufficient Amount");
        }
        if(this.invoice.method == 'visa' && !this.invoice.ref_num){
          return this.$toast("Please enter a reference number");
        }
        if(insufficient){
          var reply = await this.$swal.fire({
            title: "Confirm postpaid invoice",
            html: `
                <p>The customer <i>${this.currCustomer.name}</i></p>
                <p>paid <b>${this.formatMoney(this.invoice.paid)}</b> out of <b>${this.formatMoney(this.overall)}</b></p>
                <p>Remaining amount <b class='text-danger'>${this.formatMoney(this.overall - this.invoice.paid)} EGP</p>
                <p>will be withdrawl from balance</p>
            `,
            icon: "question", showCancelButton: true, 
            confirmButtonText: "Confirm", confirmButtonColor: "#008500", 
          });
          if(!reply.isConfirmed) return;
        }
        this.loading = true;
        var ack = await this.$service.checkout({
          type: this.invoice.type,
          method: this.invoice.method,
          ref_num: this.invoice.method == 'visa' ? this.invoice.ref_num : '',

          branch: this.currBranch,
          customer: this.currCustomer._id,
          car: (this.currCustomer._id && this.currCustomer.cars.length) ? this.invoice.car : null,
          
          delivery_address: this.invoice.delivery_address,
          delivery_fees: this.invoice.delivery_fees || 0,
          
          paid: this.invoice.paid,
          items: this.items,
        });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          $('#checkoutModal').modal('hide');
          this.$toast('Checkout Succeed', 'success');
          await this.loadCart();
          await this.$refs.invoice.view(ack.data._id);
        }
        this.loading = false;
      },
      //**********************************************************
      async onBarcodeScan(code){
        var i = this.tires.findIndex((x)=>x.barcode == code);
        if(i >= 0){
          $('#tirePickup').val(this.tires[i].id).trigger('change');
          this.tireSelected(this.tires[i]);
          return;
        }
        var j = this.others.findIndex((x)=>x.barcode == code);
        if(j >= 0){
          this.currOther = {
            id: this.others[j].id,
            name: this.others[j].text,
            price: this.others[j].price,
            amount: 1,
          }
          await this.addOtherItem();
          return;
        }
        this.$toast('Item not found');
      },
      //**********************************************************
      async showAddOther(){
        $('#addOtherProduct').modal('show');
      },
      //**********************************************************
      async otherSelected({id, text, price}){
        if(!this.currBranch) return this.$toast('Select a branch first');
        // $('#otherPickup').val(null).trigger('change');
        this.currOther.id = id;
        this.currOther.name = text;
        // this.currOther.barcode = barcode;
        this.currOther.price = price;
        this.currOther.amount = 1;
      },
      //**********************************************************
      async addOtherItem(){
        if(!this.currOther.id){
          return this.$toast('Select a product first');
        }
        if(this.currOther.amount <= 0){
          return this.$toast('Invalid Amount');
        }
        var index = this.items.findIndex((x)=>x._id == this.currOther.id);
        
        if(index < 0){
          this.items.push({
            _id: this.currOther.id,
            name: this.currOther.name,
            prod_date: '',
            price: this.currOther.price,
            quantity: this.currOther.amount,
          });
        }
        else{
          this.items[index].quantity += this.currOther.amount;
        }
        await this.saveItems();
      },
      //**********************************************************
      //**********************************************************
      translateType(type){
        if(type == 'premium_ws') return "Premium";
        if(type == 'wholesaler') return "Wholesaler";
        return 'Customer';
      },
      //**********************************************************
      //**********************************************************
    }
  }
</script>
<!-- ******************************************************** -->
<style scoped>
.inside{
    width: 100%;
    border: none;
    margin: none;
    text-align: center;
    background: none;
    outline: none;
    -moz-appearance: textfield;
}
.inside::-webkit-outer-spin-button,
.inside::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.redBox{
  background-color: #cbf5dd !important;
}

.disc-badge{
  position: absolute;
  top: 5px;
  right: 5px;
}
</style>
  